import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../Header/Logo';
import FlashMessages from '../../FlashMessages';
import MainNavigation from '../../../components/Header/MainNavigation';
import './CheckoutHeader.scss';

const noop = () => { };

class CheckoutHeader extends React.Component {
  static propTypes = {
    model: PropTypes.object.isRequired,
  };

  render() {
    const props = this.props;
    const navigationModel = props.model.prismicNavigationModel;
    const countryModel = props.model.countryModel;

    return (
      <div className="header-wrap header-wrap--checkout">
        <header
          className="header-checkout">
          <div className="container-guttered-on-desktop-up">
            <div className="header-navigation-inner-checkout">
              <div className="header-navigation-logo-checkout">
                <Logo country={countryModel} onClickLink={noop} isCheckout />
              </div>
              <MainNavigation
                country={countryModel}
                navigation={navigationModel.checkout}
                onTrackLink={noop}
                isCheckout
              />
            </div>
          </div>
          <FlashMessages />
        </header>
      </div>
    );
  }
}

export default CheckoutHeader;
